<!--
 * @Description:
 * @Author: lihaifan
 * @Date: 2021/6/17 09:43
-->
<template>
  <div>
    <div class="footer-menu">
      <div class="footer-content">
        <div class="menu-nav border">
          <dl
              v-for="(item,index) in menuList"
              :key="index"
          >
            <dt>{{ item.title }}</dt>
            <dd
                v-for="(childItem,childIndex) in item.childList"
                :key="childIndex"
                @click="openLink(childItem.link)"
            >
              {{ childItem.title }}
            </dd>
          </dl>
        </div>
        <div class="menu-nav">
          <dl>
            <dt>平台信息</dt>
            <dd>
              地址：{{ this.$store.state.user.systemInfo.areaDesc }}{{ this.$store.state.user.systemInfo.address }}
            </dd>
            <dd>
             {{ this.$store.state.user.systemInfo.companyName }}版权所有
              <span style="margin-left: 10px">v{{ version }}</span>
            </dd>
            <dd>
              <a href="https://beian.miit.gov.cn" target="_blank">备案号：京ICP备2024096292号-1</a>
            </dd>
            <dd>
              备案主体：北京盛世金图影视传媒科技有限公司
            </dd>
          </dl>
        </div>
        <div class="qrcode">
                    <p>关注我们</p>
                    <img :src="qrcode" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';
import ThirdCodeModal from './components/third-modal';

export default {
  name: 'IndexFooter',
  components: {
    ThirdCodeModal
  },
  filters: {},
  props: {},
  data () {
    return {
      version: config.version,
      menuList: [
        {
          title: '友情链接',
          childList: [
            {
              title: '中国民间中医医药研究开发协会',   
              link: 'http://www.xhctcm.com'
            },
            {
              title: '中华人民共和国民政部',
              link: 'https://www.mca.gov.cn/'
            },
            {
              title: '中华人民共和国国家卫生健康委员会',
              link: 'http://www.nhc.gov.cn/'
            },
            {
              title: '国家中医药管理局',
              link: 'http://www.natcm.gov.cn/'
            }
          ]
        }
      ]
    };
  },
  computed: {
    qrcode() {
      return this.$store.state.user.systemInfo.followQrCode
    },
    bgImg() {
      return this.$store.state.user.systemPic.bottomBgImg || '';
    },
    bgImgStyle() {
      if (this.bgImg) {
        return {
          backgroundImage: `url(${this.bgImg})`
        };
      } else {
        return {};
      }
    }
  },
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
    // 点击打开链接
    openLink (link) {
      const tempWindow = window.open('_blank');
      tempWindow.location = link;
    }
  }
};
</script>
<style lang='less' scoped>
.footer-content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.footer-menu {
  padding: 45px 0;
  background-color: #13619f;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .menu-nav {
    display: flex;

    &.border {
      padding-right: 100px;
      border-right: 1px solid rgba(255, 255, 255, 0.1);
    }

    dl {
      margin-right: 66px;

      &:last-child {
        margin-right: 0;
      }

      dt {
        font-size: 18px;
        font-weight: 700;
        color: #fff;
        margin-bottom: 15px;
      }

      dd {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 20px;
        line-height: 22px;

        .desc {
          font-size: 18px;
        }

        .qq {
          margin-left: 4px;
          width: 100px;
          height: 25px;
        }

        a {
          color: #ffffff;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .qrcode {
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;

    > img {
      width: 136px;
      height: 136px;
    }

    > p {
      margin-bottom: 9px;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
    }
  }
}
</style>
